import {
  ChartBarIcon,
  ClipboardIcon,
  ClipboardTextIcon,
  CubeIcon,
  PackageIcon,
  QrCodeIcon,
  ShieldCheckIcon,
  SquaresFourIcon,
} from '@phosphor-icons/react';
import { IResource } from '../types';

export const VENDOR_RESOURCES: Array<IResource> = [
  {
    name: 'dashboard',
    list: '/',
    meta: {
      label: 'Dashboard',
      icon: <SquaresFourIcon />,
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'grndashboard',
    list: '/grndashboard',
    meta: {
      label: 'GRN Summary',
      icon: <ChartBarIcon />,
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'mto-homepage-preview',
    list: '/mto-homepage-preview',
    meta: {
      label: 'MTO Ops Preview',
      icon: <ShieldCheckIcon />,
      masterRoles: ['NEXUS_SUPER_ADMIN'],
    },
  },
  {
    name: 'lineitems',
    list: '/lineitems',
    show: '/lineitems/show/:id',
    meta: {
      label: 'MTO PO Items',
      icon: <ClipboardTextIcon />,
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'packages',
    list: '/packages',
    show: '/packages/show/:id',
    meta: {
      label: 'Customer Orders',
      icon: <CubeIcon />,
      masterRoles: ['VENDOR_ADMIN_B2B2C'],
    },
  },
  {
    // Outgoing B2C shipment manifests for the vendor's facility; gated with Customer Orders
    // since only packages from those orders can be manifested.
    name: 'manifests',
    list: '/manifests',
    create: '/manifests/create',
    show: '/manifests/:id/show',
    meta: {
      label: 'Manifests',
      icon: <ClipboardIcon />,
      masterRoles: ['VENDOR_ADMIN_B2B2C'],
    },
  },
  {
    name: 'skus',
    list: '/skus',
    meta: {
      label: 'Catalog',
      icon: <QrCodeIcon />,
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'vendorinventory',
    list: '/vendorinventory',
    meta: {
      label: 'JIT Inventory',
      icon: <PackageIcon />,
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'returns',
    show: '/returns/show/:id',
    meta: {
      masterRoles: ['VENDOR_ADMIN'],
    },
  },
  {
    name: 'categories',
  },
];
